module.exports = __webpack_public_path__ + "img/logo_hiw.c56d2c15.png";